import type {
    AcknowledgeAction,
    CancelAction,
    ModalWindowType,
    ResolveAction,
    ReturnAction
} from './types';
import {MODAL_WINDOW_TYPES} from './types';
import type {ActionResponse} from 'typings/portaro.be.types';
import {stringifyArgument} from 'shared/utils/error-utils';


export function createCancelAction(): CancelAction {
    return {type: 'cancel'}
}

export function createAcknowledgeAction(): AcknowledgeAction {
    return {type: 'acknowledge'}
}

export function createReturnAction(value: ActionResponse): ReturnAction {
    return {type: 'return', value}
}

export function createResolveAction(value: Promise<ActionResponse>): ResolveAction {
    return {type: 'resolve', value}
}

export function isModalWindowType(type: string): type is ModalWindowType {
    return (MODAL_WINDOW_TYPES as readonly string[]).includes(type);
}

export function assertIsModalWindowType(type: string): asserts type is ModalWindowType {
    if (!isModalWindowType(type)) {
        throw new TypeError(`${stringifyArgument(type)} is not ModalWindowType! Supported types are: ${MODAL_WINDOW_TYPES.join(', ')}.`)
    }
}

export function asModalWindowType(type: string): ModalWindowType {
    assertIsModalWindowType(type);
    return type;
}